import {Component, inject, input} from '@angular/core';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {BreadcrumbResponse} from '../../../../api/client';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';

@Component({
  selector: 'app-breadcrumbs',
  imports: [CommonModule, NzMenuModule],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
  standalone: true
})
export class BreadcrumbsComponent {
  breadcrumb = input<BreadcrumbResponse[] | null>(null);
  private router = inject(Router)


  parseUrl(url: string) {
    const [path, queryString] = url.split('?');

    const queryParams: Record<string, any> = {};

    if (queryString) {
      const params = new URLSearchParams(queryString);

      params.forEach((value, key) => {
        queryParams[key] = value;
      });
    }

    return {
      path,
      queryParams
    };
  }

  navigateBreadcrumb(crumb: BreadcrumbResponse) {
    const parsed = this.parseUrl(crumb.url);
    this.router.navigate([parsed.path], {
      queryParams: parsed.queryParams
    });
  }

}
